<script>
/**
 * Profile component
 */
export default {
  components: {
  },
  props: {
    userProfile: {
      type: Object,
      default: () => {},
    },
    managePR: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      apis: 0,
      targets: 0,
      bacs: 0,
      technicalReview: 0,
      pendingItemRequests: 0,
      technicalItemRequests: 0
    };
  },
  mounted() {
  },
  methods: {
    goToProfile() {
      this.$router.push({ name: "account-settings" });
    },
    goToTechRef() {
      if(this.technicalReview == 0) return;
      this.$router.push({ name: "responsibility-center-technical" });
    },
    setData(apis, targets, bacs, technicalReview, technicalItemRequests){
      this.apis = apis;
      this.targets = targets;
      this.bacs = bacs;
      this.technicalReview = technicalReview;
      this.technicalItemRequests = technicalItemRequests;
    },
    setPIR(pendingItemRequests){
      this.pendingItemRequests = pendingItemRequests;
    },
  }
};
</script>
<template>
  <div class="card overflow-hidden">
    <div class="bg-soft bg-primary">
      <div class="row">
        <div class="col-7">
          <div class="text-primary p-3">
            <h5 class="text-primary">Welcome Back !</h5>
            <p @click="goToProfile" class="hover-underline cursor-pointer mb-0">{{userProfile.firstName}} {{userProfile.lastName}}</p>
            <p class="text-muted mb-4 text-truncate">{{$store.state.data.deliveryUnit.name}}</p>
          </div>
        </div>
        <div class="col-5 align-self-end">
          <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
        </div>
      </div>
    </div>
    <div class="card-body pt-0">
      <div class="row">
        <div class="col-sm-1">
          <div class="avatar-md profile-user-wid">
            <div
                class="
                    rounded-circle
                    profile-user
                    bg-success bg-gradient
                    text-white
                    d-flex
                    align-items-center
                    justify-content-center
                    font-size-20
                    border border-3 border-secondary
                "
            >
              <template>{{ userProfile.firstName.charAt(0).toUpperCase() }}{{ userProfile.lastName.charAt(0).toUpperCase() }}</template>
            </div>
          </div>
        </div>

        <div class="col-sm-11">
          <div class="pt-4">
            <div class="d-flex flex-mobile">
              <div class="d-flex" style="flex: 1">
                <div class="text-center" style="flex: 1">
                  <h5 class="font-size-15">{{targets}}</h5>
                  <p class="text-muted mb-0">Targets</p>
                </div>
                <div class="text-center" style="flex: 1">
                  <h5 class="font-size-15">{{apis}}</h5>
                  <p class="text-muted mb-0">APIs</p>
                </div>
              </div>
              <div class="d-flex" style="flex: 1">
                <div class="text-center" style="flex: 1">
                  <h5 class="font-size-15">{{bacs}}</h5>
                  <router-link class="text-muted mb-0 hoverable-link cursor-pointer" to="/procurement/bac">BAC <br> Approval</router-link>
                </div>
                <div class="text-center" style="flex: 1" v-if="managePR">
                  <h5 class="font-size-15">{{pendingItemRequests}}</h5>
                  <p class="text-muted mb-0 hoverable-link cursor-pointer" to="/procurement/item-requests">Item Pending <br> Requests</p>
                </div>
              </div>
              <div class="d-flex" style="flex: 1">
                <div class="text-center" style="flex: 1">
                  <h5 class="font-size-15">{{technicalReview}}</h5>
                  <p class="text-muted mb-0 hoverable-link cursor-pointer" @click="goToTechRef">Technical <br> Review</p>
                </div>
                <div class="text-center" style="flex: 1">
                  <h5 class="font-size-15">{{technicalItemRequests}}</h5>
                  <p class="text-muted mb-0 hoverable-link cursor-pointer" @click="goToTechRef">Technical <br> Item Requests</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end card-body -->
  </div>
  <!-- end card -->
</template>